export default function getCountry() {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const country = urlParams?.get("country") ?? "gb";
  return country;
}
